"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LRUCache_1 = require("./LRUCache");
const utils_1 = require("./utils");
const allCache = {};
function isDataUrl(url) {
    return url.search(/^(data:)/) !== -1;
}
function loadImage(src) {
    if (typeof Promise === "undefined") {
        console.error("Promise is not loaded. load Promise before this process.");
        return {
            then() {
                return this;
            },
        };
    }
    const img = new Image();
    const result = new Promise((resolve) => {
        img.onload = () => {
            resolve(img);
        };
    });
    img.onerror = () => {
        const url = src.length > 200 ? `${src.substr(0, 200)}...` : src;
        console.warn(`cannot load: ${url}`);
        throw new Error(`IMAGE LOAD ERROR: ${url}`);
    };
    img.src = isDataUrl(src) ? src : `${src}?${Date.now()}`;
    return result;
}
exports.loadImage = loadImage;
function getCacheOrLoad0(cache, src) {
    return utils_1.then(src, (src) => {
        const c = cache.get(src);
        if (c) {
            return c;
        }
        const result = loadImage(src).then((img) => {
            cache.put(src, img);
            return img;
        });
        cache.put(src, result);
        return result;
    });
}
function getCacheOrLoad(cacheName, cacheSize, src) {
    const cache = allCache[cacheName] ||
        (allCache[cacheName] = new LRUCache_1.LRUCache(cacheSize));
    return getCacheOrLoad0(cache, src);
}
exports.getCacheOrLoad = getCacheOrLoad;
